export default "__VITE_ASSET__BGptJjdH__"